export default "https://static.zego.com/_next/static/chunks/fonts/ModernEra-Italic-6650a6b79dc9f329572a760fa0114021.woff2";